import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./ToolboxItem.css";
import Icon from "components/library/Icon";

import { BREAKPOINT_MEDIUM } from "config/constants";

export default class ToolboxItem extends Component {
  constructor(props) {
    super(props);

    this.mediaQuery = window.matchMedia(BREAKPOINT_MEDIUM);
    this.onSizeChange = this._onSizeChange.bind(this);
    this.toggleDropdown = this._toggleDropdown.bind(this);
    this.handleOutsideClick = this._handleOutsideClick.bind(this);

    // Set the initial state for the size of component based on a media query.
    this.state = {
      isDropdownOpen: false,
      size: this.getSize(this.mediaQuery),
    };
  }

  _toggleDropdown() {
    if (this.state.isDropdownOpen) {
      this.setState({ isDropdownOpen: false });
    } else {
      this.setState({ isDropdownOpen: true });
    }
  }

  _handleOutsideClick(e) {
    if (!this.node || this.node.contains(e.target)) {
      return;
    }
    this.setState({ isDropdownOpen: false });
  }

  /**
   * When the component mounts, bind an event listener that changes its rendering when the media
   * query matches/unmatches.
   */
  componentDidMount() {
    this.mediaQuery.addListener(this.onSizeChange);
    document.addEventListener("click", this.handleOutsideClick, false);
  }

  /**
   * Remember to remove the listener when the component unmounts.
   */
  componentWillUnmount() {
    this.mediaQuery.removeListener(this.onSizeChange);
    document.removeEventListener("click", this.handleOutsideClick, false);
  }

  _onSizeChange(e) {
    this.setState({ size: this.getSize(e) });
  }

  /**
   * @param {MediaQueryList} mediaQuery
   */
  getSize(mediaQuery) {
    return mediaQuery.matches ? "large" : "medium";
  }

  render() {
    let button, item;
    if (this.state.size === "large") {
      item = <div className={styles.main}>{this.props.children}</div>;
    } else {
      button = (
        <button className={styles.button} onClick={this.toggleDropdown}>
          {this.props.name}
          <Icon name="chevron/down"></Icon>
        </button>
      );
      if (this.state.isDropdownOpen) {
        item = <div className={styles.main}>{this.props.children}</div>;
      }
    }

    return (
      <div
        className={classNames(styles.root, this.props.className, {
          [styles.centerDropdown]: this.props.centerDropdown,
          [styles.active]: this.state.isDropdownOpen,
        })}
        ref={node => {
          this.node = node;
        }}
      >
        {button}
        {item}
      </div>
    );
  }
}

ToolboxItem.propTypes = {
  centerDropdown: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  name: PropTypes.string,
};

ToolboxItem.defaultProps = {
  centerDropdown: false,
};
